<template>
  <div
    v-if="currentUser.is_login !== '1'"
    class="login_button"
    @click="click"
  >
    ログイン / 会員登録
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.login_button {
  display: none;
  @media screen and (max-width: $tabletWidth) {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 100vw;
    background-color: #000;
    color: #fff;
    padding: 20px 0;
    &:after {
      content: '';
      background-image: url('/img/double_arrow.png');
      width: 20px;
      height: 20px;
      position: absolute;
      right: 10px;
      background-size: 100%;
    }
  }
}
</style>
